// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JFv8","top":"styles_top__2SJab"};